import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  PricingPlansSettings,
  getPricingPlansSettings as universalGetPricingPlansSettings,
  updatePricingPlansSettings as universalUpdatePricingPlansSettings,
} from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/pricing-plans' };

export function getPricingPlansSettings(
  httpClient: HttpClient
): GetPricingPlansSettingsSignature {
  return () =>
    universalGetPricingPlansSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetPricingPlansSettingsSignature {
  /**
   * Retrieves a site's Pricing Plans Settings.
   * @returns Pricing Plans settings
   */
  (): Promise<NonNullablePaths<PricingPlansSettings, `taxableAddress`, 2>>;
}

export function updatePricingPlansSettings(
  httpClient: HttpClient
): UpdatePricingPlansSettingsSignature {
  return (
    pricingPlansSettings: NonNullablePaths<PricingPlansSettings, `revision`, 2>
  ) =>
    universalUpdatePricingPlansSettings(
      pricingPlansSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdatePricingPlansSettingsSignature {
  /**
   * Updates a site's Pricing Plans settings.
   *
   * Each time the Pricing Plans settings are updated, `revision` increments by 1.
   * The current `revision` must be passed when updating the Pricing Plans settings.
   * This ensures you're working with the latest Pricing Plans settings and prevents unintended overwrites.
   * @param - PricingPlansSettings to be updated, may be partial.
   * @returns Updated PricingPlansSettings.
   */
  (
    pricingPlansSettings: NonNullablePaths<PricingPlansSettings, `revision`, 2>
  ): Promise<NonNullablePaths<PricingPlansSettings, `taxableAddress`, 2>>;
}

export {
  AccountInfo,
  ActionEvent,
  Asset,
  AssignedFromFloatingReason,
  BillingReference,
  BooleanFeature,
  CancelRequestedReason,
  CancellationDetails,
  ContractSwitchClassification,
  ContractSwitchReason,
  ContractSwitchType,
  ContractSwitched,
  ContractSwitchedReason,
  Cycle,
  CycleCycleSelectorOneOf,
  DeleteContext,
  DeleteStatus,
  DomainEvent,
  DomainEventBodyOneOf,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  ExtendedFields,
  Feature,
  FeatureCancelled,
  FeatureCancelledReasonOneOf,
  FeatureContext,
  FeatureDisabled,
  FeatureDisabledReasonOneOf,
  FeatureEnabled,
  FeatureEnabledReasonOneOf,
  FeatureEvent,
  FeatureEventEventOneOf,
  FeaturePeriod,
  FeatureQuantityInfoOneOf,
  FeatureQuotaUsageChanged,
  FeatureUpdated,
  FeatureUpdatedPreviousQuantityInfoOneOf,
  FeatureUpdatedReasonOneOf,
  GetPricingPlansSettingsRequest,
  GetPricingPlansSettingsResponse,
  GuestCheckoutSettings,
  IdentificationData,
  IdentificationDataIdOneOf,
  Initiator,
  Interval,
  IntervalUnit,
  InvoiceSettings,
  ManualFeatureCreationReason,
  ManualSyncReason,
  MessageEnvelope,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  MigratedFromLegacyReason,
  Namespace,
  NamespaceChanged,
  NewFeatureReason,
  OdeditorAssigned,
  OdeditorUnassigned,
  OneTime,
  PicassoAssigned,
  PicassoUnassigned,
  PriceIncreaseTrigger,
  PricingPlansSettings,
  ProductAdjustment,
  ProductPriceIncreaseData,
  ProviderName,
  QuotaExhaustedReason,
  QuotaFeature,
  QuotaInfo,
  QuotaInfoEntry,
  ReactivationData,
  ReactivationReasonEnum,
  ReassignedFromSiteReason,
  ReassignedToAnotherSiteReason,
  RecurringChargeAttemptFailed,
  RecurringChargeFailureReason,
  RecurringChargeSucceeded,
  RefundType,
  ReplacedByAnotherSubscriptionReason,
  RestoreInfo,
  ServiceProvisioned,
  ServiceRemoved,
  SiteCreated,
  SiteCreatedContext,
  SiteDeleted,
  SiteHardDeleted,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  SitePublished,
  SitePurgedExternally,
  SiteRenamed,
  SiteTransferred,
  SiteUndeleted,
  SiteUnpublished,
  SiteUrlChanged,
  State,
  StudioAssigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  StudioUnassigned,
  Subscription,
  SubscriptionAssigned,
  SubscriptionAutoRenewTurnedOff,
  SubscriptionAutoRenewTurnedOn,
  SubscriptionCancelled,
  SubscriptionCreated,
  SubscriptionEvent,
  SubscriptionEventEventOneOf,
  SubscriptionMigratedFromVista,
  SubscriptionNearEndOfPeriod,
  SubscriptionPendingChange,
  SubscriptionStatus,
  SubscriptionTransferred,
  SubscriptionUnassigned,
  SubscriptionUpdated,
  SubscriptionVistaMigrationReverted,
  TaxableAddress,
  TransferredFromAnotherAccountReason,
  TransferredToAnotherAccountReason,
  UnAssingedToFloatingReason,
  UnassignReason,
  UpdatePricingPlansSettingsRequest,
  UpdatePricingPlansSettingsResponse,
  UserDomainMediaDisabled,
  UserDomainMediaEnabled,
  WebhookIdentityType,
  WixelAssigned,
  WixelUnassigned,
} from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.universal.js';
